import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IconButton, Tabs, Tab, Avatar,
} from '@mui/material';
import { i18n  } from '../../translate/i18n';
import {
  ArrowBack,
} from '@mui/icons-material';
import * as actions from '../../store/actions';
import { CompanyInfoContainer, CompanyInfoAvaliation, CompanyInfoTitle } from './styles';
import { renderStatusIcon } from '../../utils/statusManipulation';
import checkTenantFeatureFlag, { VIEW_MAINTENANCE, VIEW_EQUIPMENT_FINANCE } from '../../utils/checkTenantFeatureFlag';
import { EAccessRole } from '../../store/types';

const FormEquipment = (props) => {
  const dispatch = useDispatch();
  const equipmentId = props.match.params.id;
  const backPage = props.match.params.back_page;
  const backPageId = props.match.params.back_page_id;
  const [isNewData, setIsNewData] = useState(true);

  const fetchEquipmentById = useCallback(
    () => dispatch(actions.fetchEquipmentsById(equipmentId)),
    [dispatch, equipmentId],
  );

  const equipment = useSelector(state => state.equipments.equipment);
  const tenantFeatureFlags = useSelector(state => state.auth.selectedAccess.tenant.tenantFeatureFlags);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const isAdmin = selectedAccess.role === EAccessRole.admin;

  useEffect(() => {
    setIsNewData(equipmentId === 'new');
    if (equipmentId !== 'new') {
      fetchEquipmentById();
    }
  }, [equipmentId, fetchEquipmentById]);

  const EQUIP_TAB = 'equipmentTab';
  const EQUIPMENT_FINANCE_TAB = 'equipmentFinanceTab';
  const SERVICES_TAB = 'servicesTab';
  const ACTIONS_TAB = 'actionsTab';
  const TIMELINE_TAB = 'timelineTab';
  const ATTACHMENTS_TAB = 'attachmentsTab';
  const LOGS_TAB = 'logsTab';
  const MAINTENANCE_TAB = 'maintenanceTab'


  const handleChange = (event, newValue) => {
    if (newValue === EQUIP_TAB) {
      props.history.push(`/form-equip/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    } else if (newValue === EQUIPMENT_FINANCE_TAB) {
      props.history.push(`/form-equip-finance/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    } else if (newValue === SERVICES_TAB) {
      props.history.push(`/form-equip-services/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    } else if (newValue === ACTIONS_TAB) {
      props.history.push(`/form-equip-actions/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    } else if (newValue === TIMELINE_TAB) {
      props.history.push(`/form-equip-logs/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    } else if (newValue === ATTACHMENTS_TAB) {
      props.history.push(`/form-equip-attachmentFiles/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    } else if (newValue === LOGS_TAB) {
      props.history.push(`/form-equip-logs-db/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    } else if (newValue === MAINTENANCE_TAB) {
      props.history.push(`/form-equip-maintenance/${equipmentId}/${backPage}${backPageId ? `/${backPageId}` : ''}`);
    }
  };

  const handleBack = () => {
    props.history.push(`/${backPage}${backPageId ? `/${backPageId}` : ''}`);
  };

  const tabsOptions = [
    { value: EQUIP_TAB, label: `${i18n.t('tabEquip.equip')}`, showTab: true },
    { value: EQUIPMENT_FINANCE_TAB, label: `${i18n.t('tabEquip.equipFinance')}`, showTab: checkTenantFeatureFlag(VIEW_EQUIPMENT_FINANCE, tenantFeatureFlags) },
    { value: SERVICES_TAB, label: `${i18n.t('tabEquip.service')}`, disabled: props.disableServices, showTab: true },
    { value: ACTIONS_TAB, label: `${i18n.t('tabEquip.action')}`, disabled: props.Actions, showTab: true},
    { value: TIMELINE_TAB, label: `Timeline`, showTab: true },
    { value: ATTACHMENTS_TAB, label: `${i18n.t('tabEquip.attachFiles')}`, disabled: props.disableLogs, showTab: true },
    { value: LOGS_TAB, label: "Logs", showTab: isAdmin, disabled: props.disableLogs },
    { value: MAINTENANCE_TAB, label: `${i18n.t('tabEquip.maintenance')}`, showTab: checkTenantFeatureFlag(VIEW_MAINTENANCE, tenantFeatureFlags) },
  ]

  return <>
    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    {equipmentId !== 'new' &&
      <div style={styles.topContainer}>
        <CompanyInfoContainer>
          {equipment.photo
            ? <Avatar src={equipment.photo.url} style={styles.avatar} /> : <Avatar style={styles.avatarSmallText}>{i18n.t('avatarTabsEquip.photo')}</Avatar>
          }
          <CompanyInfoTitle>{equipment && equipment.equipmentModel && equipment.equipmentModel.name}</CompanyInfoTitle>
          <div style={styles.status}>{renderStatusIcon(equipment)}</div>
        </CompanyInfoContainer>
        <Tabs
          value={props.selected}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
        >
          {tabsOptions.map(t => {
            if(t.showTab) {
              return <Tab key={t.value} value={t.value} label={t.label} disabled={t.disabled} />
            }
          })}
        </Tabs>
      </div>
    }
  </>;
};

export default FormEquipment;

const styles = {
  tabs: {
    margin: '0 0 10px 60px',
  },
  topContainer: {
    margin: '0 0 10px 60px',
  },
  arrowBack: {
    position: 'fixed',
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatar: {
    width: '2.75rem',
    height: '2.75rem',
  },
  avatarSmallText: {
    fontSize: '0.775rem',
    width: '2.75rem',
    height: '2.75rem',
  },
	status: {
		marginRight: '0.25rem'
	}
};
